import { createRouter, createWebHistory } from 'vue-router'

import BarcodeChecker from '../views/barcord/Checker.vue'
import BarcodeImport from '../views/barcord/Import.vue'
import BarcodeList from '../views/barcord/List.vue'

import UploadPutupZipFile from '../views/putup/UploadZipFile.vue'
import PutupList from '../views/putup/List.vue'
import PutupChecker from '../views/putup/Checker.vue'
import PutupDownloadList from '../views/putup/DownloadList.vue'

import PutupTest from '../views/putup/Test.vue'

import Step1 from '../views/shipping/Step1.vue'
import Step2 from '../views/shipping/Step2.vue'
import Step3 from '../views/shipping/Step3.vue'
import Step4 from '../views/shipping/Step4.vue'

const routes = [
  {
    path: '/barcode_checker',
    name: 'barcodeChecker',
    component: BarcodeChecker,
    props: true,
    meta: { headerShow: false }
  },
  {
    path: '/barcode_import',
    name: 'BarcodeImport',
    component: BarcodeImport,
    meta: { headerShow: true }
  },
  {
    path: '/barcode_list',
    name: 'BarcodeList',
    component: BarcodeList,
    props: true,
    meta: { headerShow: true }
  },
  {
    path: '/putup_upload',
    name: 'UploadPutupZipFile',
    component: UploadPutupZipFile,
    meta: { headerShow: true }
  },
  {
    path: '/putup_list',
    name: 'PutupList',
    component: PutupList,
    props: true,
    meta: { headerShow: true }
  },
  {
    path: '/putup_test',
    name: 'PutupTest',
    component: PutupTest,
    meta: { headerShow: false }
  },
  {
    path: '/putup_checker',
    name: 'PutupChecker',
    component: PutupChecker,
    props: true,
    meta: { headerShow: false }
  },
  {
    path: '/putup_download_list',
    name: 'PutupDownloadList',
    component: PutupDownloadList,
    props: true,
    meta: { headerShow: true }
  },
  {
    path: '/shipping',
    name: 'Step1',
    component: Step1,
    props: true,
    meta: { headerShow: false }
  },
  {
    path: '/shipping_step2',
    name: 'Step2',
    component: Step2,
    props: true,
    meta: { headerShow: false }
  },
  {
    path: '/shipping_step3',
    name: 'Step3',
    component: Step3,
    props: true,
    meta: { headerShow: false }
  },
  {
    path: '/shipping_step4',
    name: 'Step4',
    component: Step4,
    props: true,
    meta: { headerShow: false }
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
